import React from "react";
import { BlockContainerProps, PageContainerProps } from "./dynamicPage.model";
import "@companion-core/web/src/Assets/Styles/scss/dynamicPage.scss";

export const BlockContainer = ({ children }: BlockContainerProps) => {
  return <>{children ? children : ""}</>;
};

export const PageContainer = ({ children }: PageContainerProps) => {
  return (
    <div data-testid="dynamic-page" className="dynamic-page">
      {children ? children : ""}
    </div>
  );
};
